export default __webpack_public_path__ + "static/media/download-v2.ae545cbc.svg";